import React, { Component } from "react";
import ProposalDocSection from "./proposalDocSection";
import { Redirect } from "react-router-dom";
import {
  getDocumentsTree,
  getS3File,
  getS3FileList,
  getZipFile,
} from "../../services/submissionService";
import config from "../../config";
import DropDownAction from "../common/dropDownAction";

export default class ProposalDocuments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vicusFiles: [],
      vicusFilters: [],
      tierFiles: {},
      vicusMaintenanceFiles: [],
      vicusModelExpenseRatiosFiles: [],
      vicusProgramFactSheetsFiles: [],
      vicusPerformanceFiles: [],
      fidelityMaintenanceFiles: [],
      fidelityFiles: [],
      fidelityFilters: [],
      supplementalFidFilters: [],
      supplementalVicusFilters: [],
      documentTree: [],
      registrationQualification: "",
      loading: true,
      downloads: {},
      contractKey: [],
      factSheetKey: [],
      checkedItems: {},
      downloadedItems: {},
      downloadSelectedInProgress: false,
      customForms: "",
    };
  }

  download(filename, text, contextType = "text/plain") {
    var element = document.createElement("a");
    element.setAttribute("href", `data:${contextType};base64,` + text);
    element.setAttribute("download", filename);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);

    if (this._isMounted)
      this.setState((prevState) => {
        return {
          downloadedItems: {
            ...prevState.downloadedItems,
            [filename]:
              prevState.downloadedItems[filename] >= 1
                ? prevState.downloadedItems[filename] + 1
                : 1,
          },
        };
      });
  }

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  handleDownload = async (
    prefixfilename,
    filename,
    callBackProgress,
    bucket = config.FORMS_BUCKET
  ) => {
    let text = "";
    let promises = [];
    let results = [];
    async function handlePromise(promises) {
      results = await Promise.all(promises);
    }
    // Generate download
    let result = await getS3File(bucket, prefixfilename);
    let completedPromises = 1;
    const totalPromises = result.chunks;
    callBackProgress(
      Math.round((completedPromises / parseInt(result.chunks)) * 100)
    );
    text = result.data;
    if (parseInt(result.chunks) > 1) {
      for (let index = 1; index < parseInt(result.chunks); index++) {
        promises.push(getS3File(bucket, prefixfilename, index));
      }
      handlePromise(promises);
    }
    do {
      await this.sleep(500);
      for (let index = 0; index < results.length; index++) {
        if (results[index].requestedSection === String(completedPromises)) {
          text = text + results[index].data;
          completedPromises = completedPromises + 1;
        }
      }
      callBackProgress(
        Math.round((completedPromises / parseInt(result.chunks)) * 100)
      );
    } while (String(completedPromises) !== totalPromises);
    if (this._isMounted) this.download(filename, text, result.contentType);
    text = "";
    promises = [];
    results = [];
  };

  handleToggleFile = (file, e) => {
    const id = `${file.Key.split("/")[file.Key.split("/").length - 1]}`;
    const checked = e.target.checked;
    if (checked === false) {
      let selectedItems = this.state.checkedItems;
      delete selectedItems[id];
      this.setState({ selected: selectedItems });
    } else {
      this.setState((previousState) => {
        return {
          checkedItems: {
            ...previousState.checkedItems,
            [id]: file.Key,
          },
        };
      });
    }
  };

  handleDownloadSelectedInProgress = (booleanValue) => {
    this.setState({ downloadSelectedInProgress: booleanValue });
  };

  handleDownloadSelected = async () => {
    this.handleDownloadSelectedInProgress(true);
    let response = await getZipFile(
      this.props.user,
      new Date().toUTCString(),
      Object.values(this.state.checkedItems)
    );
    
    // Parse the response - it comes back as {statusCode: 200, body: "filename.zip"}
    let filename;
    if (response?.body) {
      // The body contains the filename as a string, not JSON
      filename = response.body;
    } else if (typeof response === 'string') {
      filename = response;
    } else {
      filename = response;
    }
    
    await this.handleDownload(
      filename,
      filename,
      () => null,
      "vicus-one-day-expire"
    );
    Object.keys(this.state.checkedItems).forEach((element) => {
      if (this._isMounted)
        this.setState((previousState) => {
          return {
            downloadedItems: {
              ...previousState.downloadedItems,
              [element]: previousState.downloadedItems[element]
                ? previousState.downloadedItems[element] + 1
                : 1,
            },
          };
        });
    });
    this.handleDownloadSelectedInProgress(false);
  };

  downloadURL(Url, filename) {
    const url = Url;
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    return a;
  }

  getFiles = async () => {
    const { proposal } = this.props.location.state;
    let advisorCustomForms = "";
    let advisorEvolutionTier = [];
    if (this.props.userInfo.Advisors) {
      for (const iterator of Object.keys(this.props.userInfo.Advisors)) {
        if (
          this.props.userInfo.Advisors[iterator].Name ===
          proposal["ADVISOR NAME"]
        ) {
          advisorCustomForms =
            this.props.userInfo.Advisors[iterator].CustomForms.trim();
          this.setState({
            customForms: advisorCustomForms,
          });
          if ("EvolutionTiers" in this.props.userInfo) {
            advisorEvolutionTier = this.props.userInfo.EvolutionTiers.trim();
          }
          break;
        }
      }
    }
    let documentTreeResult = await getDocumentsTree();
    let documentTree;
    try {
      if (documentTreeResult?.body) {
        documentTree = JSON.parse(documentTreeResult.body);
      } else if (Array.isArray(documentTreeResult)) {
        documentTree = documentTreeResult;
      } else {
        documentTree = documentTreeResult;
      }
    } catch (e) {
      console.error("Error parsing document tree:", e);
      documentTree = [];
    }
    // Get Account Opening files
    let mainfolder = "public"; // public || test
    let vicusFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Account Opening/Vicus Capital Forms${
        advisorCustomForms ? ` - ${advisorCustomForms}` : ""
      }/`
    );
    let fidelityFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Account Opening/Fidelity Forms/`
    );
    let supplementalFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Account Opening/SMA Forms/`
    );
    // Get Account Maintenance files - Vicus
    let vicusMaintenanceFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Account Maintenance/Vicus Capital Forms${
        advisorCustomForms ? ` - ${advisorCustomForms}` : ""
      }/`
    );
    // Get Account Maintenance files - Fidelity
    let fidelityMaintenanceFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Account Maintenance/Fidelity Forms/`
    );

    // Get Model Expense Ratios files
    let vicusModelExpenseRatiosFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Model Expense Ratios/`
    );
    // Get account maintenance files
    let vicusProgramFactSheetsFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Program Fact Sheets/`
    );
    // Get account Performance
    let vicusPerformanceFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Performance/`
    );
    // Get Evolution Tier - Standard baseline (always fetch)
    let vicusTierStandardFiles = await getS3FileList(
      config.FORMS_BUCKET,
      `${mainfolder}/Account Opening/Vicus Capital Forms${
        advisorCustomForms ? ` - ${advisorCustomForms}` : ""
      }/Program Fee Appendices - Standard/`
    );

    const tierFilesMap = {};

    // Add Standard files to map as baseline
    if (vicusTierStandardFiles.data && vicusTierStandardFiles.data.length > 0) {
      tierFilesMap["Standard"] = vicusTierStandardFiles.data;
    }

    if (advisorEvolutionTier.length > 0) {
      const tiers = advisorEvolutionTier
        .split(";")
        .map((t) => t.trim())
        .map((t) => t.replace(/^Tier\s+/i, ""))
        .filter((t) => t.length > 0);

      const hasStandard = tiers.some((t) =>
        t.toLowerCase().includes("standard")
      );

      // Check for custom standard tiers (e.g., "Standard D&P", "Standard WK")
      const hasCustomStandardTiers = tiers.some(
        (t) => t.toLowerCase().includes("standard") && t.toLowerCase() !== "standard"
      );

      // Remove baseline Standard if user has no standard-related tier,
      // OR if they have custom standard tiers that replace the base
      if (!hasStandard || hasCustomStandardTiers) {
        delete tierFilesMap["Standard"];
      }

      // Fetch all non-"standard" tiers in parallel
      const nonStandardTiers = tiers.filter(
        (t) => t.toLowerCase() !== "standard"
      );
      // Normalize tier names to match S3 folder casing
      // Most tier parts are fully uppercase ("B WK", "E M & S", "E D&P")
      // except "Standard" which is title case ("Standard WK")
      const normalizeTierName = (tier) => {
        const upper = tier.toUpperCase();
        return upper.replace(/\bSTANDARD\b/g, "Standard");
      };
      const tierResults = await Promise.all(
        nonStandardTiers.map(async (rawTier) => {
          const tier = normalizeTierName(rawTier);
          const result = await getS3FileList(
            config.FORMS_BUCKET,
            `${mainfolder}/Account Opening/Vicus Capital Forms${
              advisorCustomForms ? ` - ${advisorCustomForms}` : ""
            }/Program Fee Appendices - Tier ${tier}/`
          );
          return { tier, files: result.data || [] };
        })
      );

      tierResults.forEach(({ tier, files }) => {
        if (files.length > 0) {
          // For custom standard tiers, filter out base Standard files
          // that don't contain the specific tier name (e.g., "Standard D&P")
          if (hasCustomStandardTiers && tier.toLowerCase().includes("standard")) {
            tierFilesMap[tier] = files.filter((file) => {
              const fileName = file.Key.split("/").pop().toLowerCase();
              return fileName.includes(tier.toLowerCase());
            });
          } else {
            tierFilesMap[tier] = files;
          }
        }
      });
    }

    if (this._isMounted) {
      this.setState({ tierFiles: tierFilesMap });
    }

    if (this._isMounted) {
      if (vicusFiles.data === undefined) vicusFiles.data = [];
      this.setState({ vicusFiles: vicusFiles.data });
      if (supplementalFiles.data === undefined) supplementalFiles.data = [];
      this.setState({ supplementalFiles: supplementalFiles.data });
      if (fidelityFiles.data === undefined) fidelityFiles.data = [];
      this.setState({ fidelityFiles: fidelityFiles.data });
      if (supplementalFiles.data === undefined) supplementalFiles.data = [];
      this.setState({ supplementalFiles: fidelityFiles.data });
      this.setState({ documentTree: documentTree });
      if (vicusMaintenanceFiles.data === undefined)
        vicusMaintenanceFiles.data = [];
      this.setState({ vicusMaintenanceFiles: vicusMaintenanceFiles.data });
      if (fidelityMaintenanceFiles.data === undefined)
        fidelityMaintenanceFiles.data = [];
      this.setState({
        fidelityMaintenanceFiles: fidelityMaintenanceFiles.data,
      });
      if (vicusModelExpenseRatiosFiles.data === undefined)
        vicusModelExpenseRatiosFiles.data = [];
      this.setState({
        vicusModelExpenseRatiosFiles: vicusModelExpenseRatiosFiles.data,
      });
      if (vicusProgramFactSheetsFiles.data === undefined)
        vicusProgramFactSheetsFiles.data = [];
      this.setState({
        vicusProgramFactSheetsFiles: vicusProgramFactSheetsFiles.data,
      });
      if (vicusPerformanceFiles.data === undefined)
        vicusPerformanceFiles.data = [];
      this.setState({
        vicusPerformanceFiles: vicusPerformanceFiles.data,
      });
    }
    this.props.registrationTypes.forEach((element) => {
      if (element.name === proposal.REGISTRATION) {
        documentTree.forEach((doc) => {
          if (doc.Name.split(" ")[0] === element["Account Type"]) {
            if (this._isMounted) {
              this.setState({
                registrationQualification: doc.Name.split(" ")[0],
              });
              this.setState({ vicusFilters: doc["Vicus Forms"] });
              this.setState({ fidelityFilters: doc["Fidelity Forms"] });
            }
          }
          if (doc.Name.toLowerCase() === "supplemental") {
            if (this._isMounted) {
              this.setState({ supplementalVicusFilters: doc["Vicus Forms"] });
              this.setState({ supplementalFidFilters: doc["Fidelity Forms"] });
            }
          }
        });
      }
    });
    this.setState({ loading: false });
  };

  componentDidMount = () => {
    this._isMounted = true;
    if (this.props.location.state !== undefined) this.getFiles();
    if (this._isMounted && this.props.location.state !== undefined) {
      const { proposal } = this.props.location.state;
      for (let index = 0; index < this.props.proposalTypes.length; index++) {
        const element = this.props.proposalTypes[index];
        if (proposal.ProgramActual === element.powerPoint) {
          this.setState({
            contractKey: element.paperwork.contract,
            factSheetKey: element.paperwork.factSheet,
          });
          break;
        }
      }
    }
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  render() {
    if (this.props.location.state === undefined)
      return <Redirect to="/proposals" />;

    const { proposal } = this.props.location.state;
    let {
      vicusFiles,
      vicusFilters,
      tierFiles,
      fidelityFiles,
      fidelityMaintenanceFiles,
      fidelityFilters,
      supplementalVicusFilters,
      supplementalFidFilters,
      vicusMaintenanceFiles,
      vicusModelExpenseRatiosFiles,
      vicusProgramFactSheetsFiles,
      vicusPerformanceFiles,
      registrationQualification,
      contractKey,
      factSheetKey,
      checkedItems,
      downloadedItems,
      downloadSelectedInProgress,
      customForms,
    } = this.state;

    return (
      <div>
        <div
          style={{
            height: "calc(100vh - 50px)",
            position: "fixed",
            width: "100vw",
            backgroundColor: "#A2AAB6",
            pointerEvents: "none",
          }}
        />

        <div className="container" style={{ paddingTop: "20px" }}>
          <div
            className="card"
            style={{ width: "100%", margin: "15px 0", borderWidth: "1px" }}
          >
            <div className="row col-12" style={{ padding: "0", margin: "0" }}>
              <h5
                style={{ padding: "10px 20px 0", fontSize: "35px", color: "#385EA4" }}
                className="col-lg-6"
              >
                Paperwork:
              </h5>
              <h5
                style={{
                  padding: "10px 20px 0",
                  fontSize: "35px",
                  textAlign: "right",
                }}
                className="col-md-6"
              >
                <DropDownAction
                  customStyle={{
                    backgroundColor:
                      Object.keys(checkedItems).length > 0
                        ? "#5cb85c"
                        : "#385EA4",
                    color: "white",
                    outline: "none",
                    border: "none",
                    height: "38px",
                  }}
                  style={{
                    outline: "none",
                    border: "none",
                    margin: "none",
                    display: "inline-flex",
                    marginRight: "5px",
                    minWidth: "92px",
                    padding: "0",
                  }}
                  ulStyle={{
                    padding: "0",
                    minWidth: "92px",
                    height: "38px",
                  }}
                  drop="dropleft"
                  title={
                    <div style={{ paddingBottom: "2px" }}>
                      {this.state.downloadSelectedInProgress === true ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : null}
                      <span
                        style={{
                          fontSize: "10px",
                          fontFamily: "none",
                        }}
                      >
                        &#9664;
                      </span>{" "}
                      Actions
                    </div>
                  }
                  items={[
                    <button
                      title="Download Selected"
                      disabled={
                        Object.keys(checkedItems).length >= 1
                          ? false
                          : true || downloadSelectedInProgress
                      }
                      style={{
                        width: "92px",
                        height: "100%",
                        backgroundColor: "#385EA4",
                        color: "white",
                        borderColor: "white",
                      }}
                      onClick={async () => {
                        this.handleDownloadSelected();
                      }}
                      className="col btn btn-sm"
                    >
                      <span style={{ fontSize: "15px" }}>Download</span>
                    </button>,
                  ]}
                />
              </h5>
            </div>
            <ProposalDocSection
              downloadedItems={downloadedItems}
              checkedItems={checkedItems}
              handleToggleFile={this.handleToggleFile}
              downloadAllInProgress={this.downloadAllInProgress}
              title="Vicus Capital Paperwork:"
              values={proposal}
              qualification={registrationQualification}
              files={
                contractKey.length > 0
                  ? vicusFiles
                      .filter((file) => {
                        return !file.Key.includes("Proposal Request");
                      })
                      .filter((file) => {
                        if (!file.Key) return false;

                        const fileName = file.Key.split("/")[file.Key.split("/").length - 1]
                          .replaceAll(customForms, "")
                          .trim()
                          .toLowerCase();

                        // Check if filename starts with any of the contract keys
                        // (startsWith prevents "CoreOps" from matching "ESG Focused CoreOps" files)
                        for (let i = 0; i < contractKey.length; i++) {
                          const contractName = contractKey[i]
                            .toString()
                            .replaceAll(customForms, "")
                            .trim()
                            .toLowerCase();

                          if (fileName.startsWith(contractName)) {
                            return true;
                          }
                        }
                        return false;
                      })
                      .filter((file) => {
                        return !file.Key.toLowerCase().includes("rfp");
                      })
                      .sort((file1, file2) => {
                        // Get full filename without extension, keeping all parts except the date (last part)
                        const file1Parts = file1.Key.split("/")[file1.Key.split("/").length - 1].split(".")[0].split("_");
                        const file2Parts = file2.Key.split("/")[file2.Key.split("/").length - 1].split(".")[0].split("_");

                        const file1Name = file1Parts.slice(0, -1).join("_")
                          .replaceAll(customForms, "")
                          .trim();
                        const file2Name = file2Parts.slice(0, -1).join("_")
                          .replaceAll(customForms, "")
                          .trim();

                        if (file1Name < file2Name) {
                          return -1;
                        }
                        if (file1Name > file2Name) {
                          return 1;
                        }
                        return 0;
                      })
                      .concat(
                        contractKey.length > 0
                          ? Array.from(
                              new Set(
                                Object.values(tierFiles).flat()
                              )
                            )
                              .filter((file) => {
                                if (!file.Key) return false;

                                const fileName = file.Key.split("/")[file.Key.split("/").length - 1]
                                  .replaceAll(customForms, "")
                                  .trim()
                                  .toLowerCase();

                                // Check if filename starts with any of the contract keys
                                for (let j = 0; j < contractKey.length; j++) {
                                  const contractName = contractKey[j]
                                    .toString()
                                    .replaceAll(customForms, "")
                                    .trim()
                                    .toLowerCase();

                                  if (fileName.startsWith(contractName)) {
                                    return true;
                                  }
                                }
                                return false;
                              })
                              .filter((file) => {
                                return !file.Key.toLowerCase().includes("rfp");
                              })
                          : []
                      )
                      .concat(
                        contractKey.length > 0
                          ? vicusFiles.filter((file) => {
                              for (
                                let index = 0;
                                index < vicusFilters.length;
                                index++
                              ) {
                                const element = vicusFilters[index];
                                if (
                                  element.includes(
                                    file.Key.split("/")
                                      [file.Key.split("/").length - 1].split(
                                        "."
                                      )[0]
                                      .split("_")[0]
                                      .replaceAll(customForms, "")
                                      .trim()
                                  )
                                ) {
                                  return true;
                                }
                              }
                              return false;
                            })
                          : undefined
                      )
                  : undefined
              }
              supplementalFiles={vicusProgramFactSheetsFiles
                .filter((file) => {
                  for (let i = 0; i < factSheetKey.length; i++) {
                    if (
                      file.Key &&
                      file.Key.toString()
                        .split("/")
                        [file.Key.toString().split("/").length - 1].split(
                          "_"
                        )[0]
                        .replaceAll(customForms, "")
                        .trim()
                        .toLowerCase() ===
                        factSheetKey[i]
                          .toString()
                          .replaceAll(customForms, "")
                          .trim()
                          .toLowerCase()
                    ) {
                      return true;
                    }
                  }
                  return false;
                })
                .concat(
                  [
                    ...new Set([
                      ...vicusFiles,
                      ...vicusMaintenanceFiles,
                      ...vicusModelExpenseRatiosFiles,
                      ...vicusPerformanceFiles,
                    ]),
                  ]
                    .filter((v, i, a) => {
                      return (
                        a.findIndex(
                          (t) => {
                            // Get filename without path and extension
                            const tFileName = t.Key.split("/")[t.Key.split("/").length - 1].split(".")[0];
                            const vFileName = v.Key.split("/")[v.Key.split("/").length - 1].split(".")[0];

                            // Get base name (all parts except the last, which is typically the date)
                            const tBaseName = tFileName.split("_").slice(0, -1).join("_")
                              .replaceAll(customForms, "")
                              .trim();
                            const vBaseName = vFileName.split("_").slice(0, -1).join("_")
                              .replaceAll(customForms, "")
                              .trim();

                            return tBaseName === vBaseName;
                          }
                        ) === i
                      );
                    })
                    .filter((file) => {
                      return !file.Key.includes("Proposal Request");
                    })
                    .filter((file) => {
                      for (
                        let index = 0;
                        index < supplementalVicusFilters.length;
                        index++
                      ) {
                        const element = supplementalVicusFilters[index];
                        if (
                          element ===
                          file.Key.split("/")
                            [file.Key.split("/").length - 1].split("_")[0]
                            .replaceAll(customForms, "")
                            .trim()
                        ) {
                          return true;
                        }
                      }
                      return false;
                    })
                    .filter((file) => {
                      for (
                        let index = 0;
                        index < supplementalVicusFilters.length;
                        index++
                      ) {
                        const element = supplementalVicusFilters[index];
                        if (
                          element ===
                          file.Key.split("/")
                            [file.Key.split("/").length - 1].split("_")[0]
                            .replaceAll(customForms, "")
                            .trim()
                        ) {
                          return true;
                        }
                      }
                      return false;
                    })
                    .sort((file1, file2) => {
                      // Get full filename without extension, keeping all parts except the date (last part)
                      const file1Parts = file1.Key.split("/")[file1.Key.split("/").length - 1].split(".")[0].split("_");
                      const file2Parts = file2.Key.split("/")[file2.Key.split("/").length - 1].split(".")[0].split("_");

                      const file1Name = file1Parts.slice(0, -1).join("_")
                        .replaceAll(customForms, "")
                        .trim();
                      const file2Name = file2Parts.slice(0, -1).join("_")
                        .replaceAll(customForms, "")
                        .trim();

                      if (file1Name < file2Name) {
                        return -1;
                      }
                      if (file1Name > file2Name) {
                        return 1;
                      }
                      return 0;
                    })
                )}
              handleDownload={this.handleDownload}
              downloadURL={this.downloadURL}
              loading={this.state.loading}
            />
            <ProposalDocSection
              downloadedItems={downloadedItems}
              checkedItems={checkedItems}
              handleToggleFile={this.handleToggleFile}
              downloadAllInProgress={this.downloadAllInProgress}
              title="Fidelity Paperwork:"
              values={proposal}
              qualification={registrationQualification}
              files={fidelityFiles
                .filter((file) => {
                  return !file.Key.includes("Proposal Request");
                })
                .sort()
                .filter((file) => {
                  for (let index = 0; index < fidelityFilters.length; index++) {
                    const element = fidelityFilters[index];
                    if (
                      element.includes(
                        file.Key.split("/")
                          [file.Key.split("/").length - 1].split(".")[0]
                          .split("_")[0]
                          .replaceAll(customForms, "")
                          .trim()
                      )
                    ) {
                      return true;
                    }
                  }
                  return false;
                })}
              supplementalFiles={[
                ...new Set(
                  fidelityMaintenanceFiles
                    ? [...fidelityMaintenanceFiles, ...fidelityFiles]
                    : [...fidelityFiles]
                ),
              ]
                .filter((file) => {
                  return !file.Key.includes("Proposal Request");
                })
                .filter((file) => {
                  for (
                    let index = 0;
                    index < supplementalFidFilters.length;
                    index++
                  ) {
                    const element = supplementalFidFilters[index];
                    if (
                      element.includes(
                        file.Key.split("/")
                          [file.Key.split("/").length - 1].split(".")[0]
                          .split("_")[0]
                          .replaceAll(customForms, "")
                          .trim()
                      )
                    ) {
                      return true;
                    }
                  }
                  return false;
                })}
              handleDownload={this.handleDownload}
              downloadURL={this.downloadURL}
              loading={this.state.loading}
            />
          </div>
        </div>
      </div>
    );
  }
}
